<template>
  <!--srcviewscompanydetailsvuehtmlStart-->
  <!-- 详情 -->
  <div
    id="defaultId1"
    class="trade-theme"
    name="header"
    ref="scrollContainer"
    @scroll="handleScroll"
  >
    <Headers></Headers>
    <content_view id="gc95c2" ref="contentView">
      <template slot="header">
        <div id="gd2da8" class="uVNPU6M">
          <tools
            id="g9a4e3"
            class="u35ff0"
            :config="$store.state.app.toolsConfig"
            @clickMenu="clickMenu"
            ref="tools"
          >
          </tools>
        </div>
      </template>
      <template slot="details_view">
        <div id="g30b5a" class="ud2d40">
          <!-- style="width: 43.5%" -->
          <div id="ga36b2" class="c flex_between_box" style="width: 100%">
            <div>
              <div class="hsDes">
                <img id="gf2e43" class="uc6a2b" :src="countryImg" alt="" />
                {{ getCountry($route.query.id3a) }}
              </div>
              <div id="g1d5a8" class="u83191">
                <div class="flex_center">
                  <div class="HsCode">
                    {{ $t("TradeByCountry.ISO") }} : {{ isoCode }}
                  </div>
                  <div class="HsCode HsCodePadding">
                    {{ $t("TradeByCountry.Currency") }} : {{ Currency }}
                  </div>
                  <div class="HsCode">
                    {{ $t("TradeByCountry.Language") }} :{{ Language }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="g29da1" class="ubf224">
          <div id="g06fa7" class="ue896e">
            <ul id="ga9199" class="ufb44d">
              <div id="g251bf"></div>
              <li
                id="ga557d"
                @click="openUrl(item, '')"
                v-for="(item, index) in breadcrumbBar"
                :key="index"
                v-show="item.isShow"
                :class="tab1ActiveName == item.id ? 'bread_active' : ''"
                class="trade_tab_item"
              >
                <div
                  class="textu99b63"
                  :class="tab1ActiveName == item.id ? 'bread_active2' : ''"
                >
                  {{ item.screenName }}
                </div>
              </li>
            </ul>
          </div>
          <div id="g599f6" v-show="isShowMoreMark" class="u2ac23 mb10">
            <div
              id="gfff13"
              class="u8bb4e"
              v-if="markTotalList.length > 0"
              :class="[isNoShowTab2 != 'showMark' ? 'mt0' : 'mt0']"
            >
              <div v-for="(item, index) in markTotalList" :key="index">
                <gui_mark_total
                  :MoudeImg="'images/tradejiugonge.png'"
                  id="g9eda6"
                  class="u661e6"
                  :label="item.name"
                  :total="item.num"
                  v-if="item.num != '-'"
                >
                </gui_mark_total>
              </div>
            </div>
          </div>
          <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
            <button class="showBackToTop">
              <svg
                t="1732090638802"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6153"
                width="20"
                height="20"
              >
                <path
                  d="M564.4 213.7C549.9 199.2 530.9 192 512 192c-19 0-38 7.2-52.5 21.7L73.4 599.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l361.3-361V928c0 17.7 14.3 32 32 32s32-14.3 32-32V283.7l361.4 361c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L564.4 213.7zM96 129l832-1c17.7 0 32-14.4 32-32 0-17.7-14.3-32-32-32L96 65c-17.7 0-32 14.4-32 32 0 17.7 14.3 32 32 32z"
                  p-id="6154"
                  fill="#FFFFFF"
                ></path>
              </svg>
            </button>
          </div>

          <div id="g1e372" class="u0c804">
            <router-view
              ref="route"
              :companyBaseRoute="company"
              id="cb02bf"
              @UpdatamarkTotalList="childUpdatamarkTotalList"
            >
            </router-view>
          </div>
        </div>
      </template>
    </content_view>

    <Suo
      :suoClose="Update"
      @closeCloseDialog="clossuoDialog($event)"
      @closeCloseDialog1="clossuoDialog1($event)"
    ></Suo>

    <el-dialog
      :visible.sync="hasPrivilege"
      center
      :close-on-click-modal="true"
      @close="chasPrivilegeDialog"
      custom-class="dialog_normalsuo dialog_normalpower"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center">
            <img
              class="powerdengpao"
              src="@/assets/images/powerdengpao.png"
              alt=""
            />
          </div>
          <div class="detail_cont_text">
            {{ $t("SearchTrade.detailconttext") }}
          </div>
        </div>
      </div>
      <div class="flex_center">
        <!-- <el-button
          class="btn_export btn_exportCCC"
          @click="hasPrivilege = false"
          >{{ $t("SearchTrade.OK") }}</el-button
        > -->
        <el-button
          class="btn_export"
          @click="
            $router.push({
              path: '/index/addCredit',
            })
          "
          >{{ $t("SearchTrade.Subscribe") }}</el-button
        >
      </div>
    </el-dialog>
    <PermissionDialog></PermissionDialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

import { formatNum } from "@/views/company/details/Background/utils";
import Headers from "@/views/newLayout/header.vue";
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import { mixins1 } from "@/mixins/index";
import content_view from "../layout/content_view.vue";
import gui_tabs from "../../components/gui_tabs/gui_tabs.vue";
import gui_tab_item from "../../components/gui_tabs/gui_tab_item.vue";
import gui_collapse from "../../components/gui_collapse/gui_collapse.vue";
import gui_checkbox from "../../components/gui_checkbox/gui_checkbox.vue";
import gui_scroll_x from "../../components/gui_scroll_x/gui_scroll_x.vue";
import gui_link_content from "../../components/gui_link_content/gui_link_content.vue";
import { goAnchor, GetQueryString } from "../../utils/anchor.js";
import * as echarts from "echarts/core";
import { menuRouter, tabList } from "../../config/index.js";
import { showCountryData } from "@/api/companyApi.js";
import gui_mark_total from "../../components/gui_mark_total/gui_mark_total.vue";
import tools from "@/views/layout/tools.vue";
import Suo from "./list/UpdateDialog.vue";
import ReLogin from "../../components/ReLogin.vue";
//importEnd
import {
  downloadOnlinePdf,
  whetherDeductPoints,
  getTabListOneLayer,
} from "@/api/userApi";
export default {
  name: "",
  mixins: [mixins1],
  props: {},
  watch: {
    $route(to, from) {
      // 在路由变化时执行的代码
      if (to.name == "businessActivitiesimport&Export") {
        this.tab2ActiveName = to.query.idpower;
      }
    },
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
        } else {
          this.setToolsfalse();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.state.app.toolsConfig.creditAssessment.isShow = false;
    this.$store.state.app.toolsConfig.dataAnalysis.isShow = false;
    this.$store.state.app.toolsConfig.customPortfolio.isShow = false;
    this.$store.state.app.toolsConfig.print.isShow = false;
    this.$store.state.app.toolsConfig.riskScanning.isShow = false;
    this.$store.state.app.toolsConfig.sort.isShow = false;
    this.$store.state.app.toolsConfig.sort.isActive = false;
    this.gettabList();
    let countryImg = this.getCountryImgUrl(this.$route.query.id3a);
    this.countryImg = require("../../../static" + countryImg);
    this.setThemeColor();
    this.setToolsfalse();
    document.title = this.getCountry(this.$route.query.id3a);
  },
  created() {
    this.getCompanySnaplist();
    window.addEventListener("scroll", this.handleScroll);
    this.whetherDeductPointsDetail();
  },
  beforeUnmount() {
    // 移除页面滚动事件的监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  active() {},

  components: {
    Headers,
    PermissionDialog,
    Suo,
    tools,
    gui_mark_total,
    content_view,
    gui_tabs,
    gui_tab_item,
    gui_collapse,
    gui_checkbox,
    gui_scroll_x,
    gui_link_content,
    ReLogin,
  },

  data() {
    return {
      showBackToTop: false,
      countryImg: "",
      reLoginVis: false,
      isoCode: "",
      Currency: "",
      Language: "",
      UpdateStatus: 0,
      Compare: false,
      ReportError: false,
      powerToReportErrorStatus: false,
      Update: false,
      Download: false,
      hasPrivilege: false,

      // option2
      company: null,
      compareList: [],

      HsCodeObject: {
        hsCode: "",
        hsCodeDescription: "",
        productCode: "",
        productCodeDescription: "",
      },
      toolsConfig: {
        menu: {
          isShow: true,
          isActive: true,
        },

        filter: {
          isShow: false,
          isActive: false,
        },

        select: {
          isShow: true,
          isActive: false,
        },

        edit: {
          isShow: true,
          isActive: false,
        },

        sort: {
          isShow: true,
          isActive: false,
        },

        collect: {
          isShow: true,
          isActive: false,
        },

        saved: {
          isShow: true,
          isActive: false,
        },

        compare: {
          isShow: true,
          isActive: false,
        },

        export: {
          isShow: true,
          isActive: false,
        },

        download: {
          isShow: true,
          isActive: false,
        },

        update: {
          isShow: true,
          isActive: false,
        },

        reportError: {
          isShow: true,
          isActive: false,
        },

        riskScanning: {
          isShow: true,
          isActive: false,
        },
        creditAssessment: {
          isShow: true,
          isActive: false,
        },
        dataAnalysis: {
          isShow: true,
          isActive: false,
        },
        customPortfolio: {
          isShow: true,
          isActive: false,
        },
        print: {
          isShow: true,
          isActive: false,
        },
        share: {
          isShow: true,
          isActive: false,
        },
      },
      // option1

      // isShowMenu
      isShowMenu: true,

      // star
      star: false,
      // isShowMoreMark
      isShowMoreMark: true,
      // markList
      markList: [],
      // breadcrumbBar
      // breadcrumbBar: tabList,
      breadcrumbBar: [],
      // tab1ActiveName
      tab1ActiveName: "Business Activities",
      // isNoShowTab2
      isNoShowTab2: false,
      hasPrivilege: false,
      // 背景样式
      tab2BkStyle: {
        width: "",
        height: "",
        left: "",
        top: "",
        display: "block",
      },
      // tab2_list
      tab2_list: ["Snapshot", "Profile", "Ownership"],
      // tab2ActiveName
      tab2ActiveName: "Snapshot",
      // markTotalList
      markTotalList: [],
      CreditScore: "",
      token: localStorage.getItem("token"),
      // srcviewscompanydetailsvueDataEnd
    };
  },
  methods: {
    setToolsfalse() {
      // this.$store.dispatch("app/setTools", {
      //           name: "menu",
      //           key: "isActive",
      //           value: false,
      //       });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
    },

    handleScroll() {
      // 判断页面滚动距离是否超过200px，更新showBackToTop的值
      const scrollTop = this.$refs.scrollContainer.scrollTop;
      // console.log(`window.pageYOffset`, window.pageYOffset);
      this.showBackToTop = scrollTop > 390;
    },
    scrollToTop() {
      const container = this.$refs.scrollContainer; // 使用 ref 获取容器
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 使用scrollTo()方法将页面滚动到顶部
      // window.scrollTo({
      //     top: 0,
      //     behavior: 'smooth',
      // });
    },
    whetherDeductPointsDetail() {
      if (this.$route.query.id3a) {
        whetherDeductPoints({
          companyAaaid: this.$route.query.id3a,
        }).then((res) => {
          this.UpdateStatus = res.data.status;
          if (this.UpdateStatus == 6 || this.UpdateStatus == 2) {
            // this.toolsConfig.update.isActive = false
          }
        });
      }
    },
    gettabList() {
      getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleType: 10,
      }).then((res) => {
        let routerName = this.$route.name;

        if (res.code == 200) {
          this.breadcrumbBar = res.data;
          let moduleId =
            res.data.find((item) => routerName.includes(item.name))?.id || null;
          this.tab1ActiveName = moduleId;
          if (moduleId) {
            getTabListOneLayer({
              aaaId: this.$route.query.id3a,
              moduleId: moduleId,
            }).then((res) => {
              this.tab2_list = res.data;
              let tab2ActiveName =
                res.data.find((item) => routerName.includes(item.name))?.id ||
                null;
              this.tab2ActiveName = tab2ActiveName;
            });
          }
          let arr = [];
          res.data.map((item, index) => {
            // || item.name == 'marketAnalysis'
            if (item.name == "creditOpinion") {
              arr.push({
                id: item.name,
                name: item.screenName,
                children:
                  item.name == "creditOpinion"
                    ? [{ name: "tab2", id: "list" }]
                    : [
                        {
                          name: "tab2",
                          id: "list",
                          children: [],
                        },
                      ],
                isShow: item.isShow,
                //   item.hasPrivilege
                hasPrivilege: true,
                isNoShowTab2:
                  item.name == "creditOpinion" ? "noShowAll" : "showMark",
              });
            } else {
            }
          });
        }
      });
    },
    //关闭report弹窗
    closeDialog(value) {
      this.ReportError = value;
    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false;
    },
    clossuoDialog(value) {
      this.Update = value;
    },
    clossuoDialog1(value) {
      // this.suopower = value;
    },
    CompareShow(val) {
      this.Compare = false;
    },

    childUpdatamarkTotalList(value) {
      this.isShowMoreMark = value;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
 
    // insertMethod
    // srcviewscompanydetailsvueMethodStart
    // initTab
    getCompanySnaplist() {
      const id3a = this.$route.query.id3a;

      showCountryData({
        countryCode: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.isoCode = res.data?.isoCode;
            this.Currency = res.data?.currency;

            this.Language = res.data?.language;
            this.markTotalList = [
              {
                name: this.$t("TradeByCountry.TotalImportAmount"),
                num: formatNum( res.data.importAmount),
              },
              {
                name: this.$t("TradeByCountry.GlobalImportShare"),
                num: formatNum( res.data.importPctWorld),
              },
              {
                name: this.$t("TradeByCountry.ImportGrowth"),
                num: formatNum( res.data.importAgr),
              },
              {
                name: this.$t("TradeByCountry.TotalExportAmount"),
                num: formatNum( res.data.exportAmount),
              },
              {
                name: this.$t("TradeByCountry.GlobalExportShare"),
                num: formatNum( res.data.exportPctWorld),
              },
              {
                name: this.$t("TradeByCountry.ExportGrowth"),
                num:  formatNum(res.data.exportAgr),
              },
              {
                name: this.$t("TradeByCountry.TradeBalance"),
                num: formatNum( res.data.tradeBalance),
              },
            ];

            console.log(this.markTotalList);
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    initTab() {
      let routes = {};
      this.breadcrumbBar.forEach((item) => {
        item.children.forEach((item2) => {
          let obj = {
            tab1: item.id,
            tab2: item2.id,
            isNoShowTab2: item.isNoShowTab2,
            tab2List: item.children,
          };
          routes[item.id + item2.id] = obj;
        });
      });

      let routerName = this.$route.name;

      this.tab1ActiveName = routes[routerName].tab1;
      this.tab2ActiveName = routes[routerName].tab2;
      this.tab2_list = routes[routerName].tab2List;

      let markTotal = this.tab2_list.find(
        (item) => item.id == this.tab2ActiveName,
      );

      let isNoShowTab2 = routes[routerName].isNoShowTab2;

      if (isNoShowTab2) {
        this.isNoShowTab2 = isNoShowTab2;
      } else {
        this.isNoShowTab2 = false;
      }
    },

    // clickMenu 控制详情
    clickMenu(name, data) {
      switch (name) {
        case "menu":
          this.$store.dispatch("app/toggleMenu", !this.$store.state.app.isMenu);
          break;
        case "select":
          this.$nextTick(() => {
            if (this.$refs.route.isOpenSlct) {
              this.$refs.route.isOpenSlct = false;
              this.$refs.route.isOpenSlct = false;
            } else {
              this.$refs.route.isOpenSlct = "Select";
              this.$refs.route.isOpenSlct = "Select";
            }
          });
          break;
        case "Update":
          this.Update = true;

          break;
        case "download":
          this.Download = true;
          downloadOnlinePdf(this.$route.query.id3a)
            .then((res) => {
              const binaryData = [];
              binaryData.push(res);
              let pdfUrl = window.URL.createObjectURL(
                new Blob(binaryData, { type: "application/pdf" }),
              );
              window.open(pdfUrl, "_blank");
            })
            .catch((err) => {
              this.reLoginVis = String(err).includes("403");
            });
          break;
        case "Compare":
          this.Compare = true;
          break;

        case "Report":
          this.ReportError = true;
          this.powerToReportErrorStatus = true;
          break;

        case "edit":
          if (this.$refs.route && "columns" in this.$refs.route) {
            this.$refs.route.columns = data;
          } else if (this.$refs.route) {
            this.$refs.route.columns = data;
          }
          break;
      }
    },

    // toggleMoreMark

    openUrl(tab1Name, tab2Name) {
      let SACode1 = "";

      if (tab1Name?.hasPrivilege || tab2Name?.hasPrivilege) {
        if (!tab1Name) {
          let tab1NameVal = this.breadcrumbBar.find(
            (item) => item.id == this.tab1ActiveName,
          )?.name;
          let tab2NameVal = tab2Name.name;
          this.tab2ActiveName = tab2Name.id;

          this.$router.push({
            name: "TradeCountryDetails" + tab1NameVal + tab2NameVal,
            params: {
              id: this.$route.params.id,
              idpower: tab2Name?.id,
            },
            query: {
              id3a: this.$route.query.id3a,
              companyCountry: this.company.base.countryFlag,
              SACode1: SACode1,
              idpower: tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
              companyName: this.$route.query.companyName,
              Tradechannel: this.$route.query.Tradechannel,
              Moudles: "Trade",
            },
          });
        } else {
          this.tab1ActiveName = tab1Name?.id;
          getTabListOneLayer({
            aaaId: this.$route.query.id3a,
            moduleId: tab1Name?.id,
          }).then((res) => {
            if (res.data.length > 0) {
              this.tab2_list = res.data.filter((item) => item.isShow == true);
              if (this.tab2_list.length > 0) {
                this.isNoShowTab2 = "";
                this.tab2ActiveName = this.tab2_list[0]?.id;
                this.$router.push({
                  name:
                    "TradeCountryDetails" +
                    tab1Name.name +
                    this.tab2_list[0]?.name,
                  params: {
                    id: this.$route.params.id,
                    idpower: tab2Name?.id,
                  },
                  query: {
                    id3a: this.$route.query.id3a,
                    companyCountry: this.company.base.countryFlag,
                    SACode1: SACode1,
                    idpower:
                      tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                    companyName: this.$route.query.companyName,
                    Moudles: "Trade",
                    Tradechannel: this.$route.query.Tradechannel,
                  },
                });
              }
            } else {
              // if (tab1Name?.name == 'creditOpinion') {
              //   this.isNoShowTab2 = "noShowAll"
              // }
              // this.tab2_list = tab1Name?.name == 'creditOpinion' ? [{ name: 'tab2', id: 'list', }] :

              this.$router.push({
                name: "TradeCountryDetails" + tab1Name.name,
                params: {
                  id: this.$route.params.id,
                  idpower: tab2Name?.id,
                },
                query: {
                  id3a: this.$route.query.id3a,
                  companyCountry: this.$route.query.companyCountry,

                  SACode1: SACode1,
                  idpower:
                    tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                  companyName: this.$route.query.companyName,
                  Tradechannel: this.$route.query.Tradechannel,
                  Moudles: "Trade",
                },
              });
            }
          });
        }
      } else {
        this.hasPrivilege = true;
      }
    }, // 离开悬浮
    leaveTab2(event) {
      this.tab2BkStyle.display = `none`;
    }, // 悬浮tab2监听
    overTab2(e) {
      let event = e;
      const rect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentNode.getBoundingClientRect();
      this.tab2BkStyle.width = `${rect.width}px`;
      this.tab2BkStyle.height = `${rect.height}px`;
      this.tab2BkStyle.left = `${rect.left - parentRect.left}px`;
      this.tab2BkStyle.top = `${rect.top - parentRect.top}px`;
      this.tab2BkStyle.display = `block`;
    }, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#009EA7");
      this.$store.dispatch("app/setSearchType", "TradeDetail");
    },
    // srcviewscompanydetailsvueMethodEnd
  },
  computed: {},
};
</script>
<style>
.uVNPU6H,
.uVNPU6M {
  width: 100%;
}

.u35ff8 {
  width: 100%;
  overflow: hidden;
}

.ud2d40 {
  display: flex;
  min-height: 230px;
  padding-top: 20px;
  padding-left: 3.5%;
  padding-right: 3.5%;
  background-color: #009ea7;
}

.u4f5b {
  display: block;
  justify-content: flex-start;
  align-items: flex-start;
  border-color: rgb(172, 201, 24);
  color: rgb(255, 255, 255);
}

.uc4421 {
  color: rgb(255, 255, 255);
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
  padding-top: 0rem;
  padding-left: 0rem;
  padding-right: 0rem;
  padding-bottom: 0rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uc4421_text {
  font-size: 2.57rem;
  font-family: "Arial Bold";
  overflow: hidden;
  text-overflow: ellipsis;
}

.u0e1f6 {
  display: flex;
  align-items: center;
  margin-top: 1.28em;
  margin-bottom: 0.85rem;
  flex-direction: row;
}

.uc6a2b {
  width: 50px;
  height: 30px;
}

.u83191 {
  display: flex;
  margin-top: 18px;
}

.ubb08b {
  color: rgb(255, 255, 255);
  font-size: 1.285714rem;
  height: auto;
  overflow-y: auto;
  min-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u5b01d {
  color: rgb(255, 255, 255);
  margin-top: 1.4285714285714286rem;
  font-size: 1.14285714rem;
}

.uboa8Fv {
  display: flex;
}

.u9KBSet {
  transform: rotate(1deg);
}

.ubf224 {
  margin-top: -8.92rem;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  z-index: 99;
}

.ue896e {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: -0.21428571428571427rem;
}

.ufb44d {
  display: flex;
  flex-direction: row;
  text-align: center;
}

.trade_tab_item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  color: rgb(255, 255, 255);
  margin-right: 14px;
  line-height: 22px;
  padding: 14px 20px 10px;
  background-color: #32b1b8;
  text-align: center;
  border-radius: 5px 5px 0px 0px;
  box-sizing: border-box;
  cursor: pointer;
}

.textu99b63 {
  font-size: 18px;
}

.u99b63:last-child {
  margin-right: 0;
}

.bread_active {
  font-family: "Arial Bold" !important;
  background-color: rgb(255, 255, 255);
}
.bread_active2 {
  font-family: "Arial Bold" !important;
  color: #009ea7;
}
.tab2_active {
  background-color: rgb(255, 255, 255);
  z-index: 10;
  font-weight: 400;
  font-family: "Arial Bold";
}

.u8bb4e {
  display: flex;
}

.u661e6 {
  margin-right: 5px;
  margin-left: 5px;
  height: 100%;
}

.u0c804 {
  border-radius: 5px;
}

.uboa8Fv .submore {
  height: 5rem;
  overflow-y: auto;
  margin-right: 2.142857142857143rem;
}

.u0a580 .subsvg {
  transform: rotate(180deg);
}

.back-to-top {
  z-index: 99999;
  position: fixed;
  transition: opacity 0.4s ease-in-out 0s;
  opacity: 1;
  box-sizing: border-box;
  bottom: 10.714285714285714rem;
  right: 1.7857142857142858rem;
  cursor: pointer;
}

.showBackToTop {
  width: 2.857142857142857rem;
  height: 2.857142857142857rem;
  background: #009ea7;
  border-radius: 50%;
  box-shadow: 0rem 0.14285714285714285rem 0.7142857142857143rem 0rem
    rgba(0, 122, 177, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.borderLIne {
  margin-right: 2.857rem;
  padding-right: 2.857rem;
  border-right: 1px solid #ffffff;
  font-style: normal;
  font-weight: 400;
}

.hsDes {
  font-size: 36px;
  color: #ffffff;
  font-family: "Arial Bold";
  line-height: 48px;
}
.hsDestwo {
  font-size: 1.85714286rem;
  color: #ffffff;
  display: -webkit-box;
  font-family: "Arial Bold";
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 5rem;
}

.HsCode {
  font-size: 18px;
  color: #ffffff;
}
.HsCodePadding {
  padding: 0 20px;
  border-left: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
  margin: 0 20px;
  line-height: 12px;
}
.hsDestwo {
  margin-top: 1rem;
  font-size: 1.285714rem;
  color: #ffffff;
}
.u2ac23 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  padding: 20px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

@media screen and (max-width: 1920px) {
  .uc6a2b {
    width: 38px;
    height: 23px;
  }

  .u83191 {
    display: flex;
    margin-top: 14px;
  }

  .hsDes {
    font-size: 27px;
    color: #ffffff;
    font-family: "Arial Bold";
    line-height: 36px;
  }
  .u2ac23 {
    padding: 15px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .trade_tab_item {
    margin-right: 10px;
    line-height: 18px;
    padding: 10px 15px 7px;
  }
  .ubb08b,
  .u5b01d,
  .textu99b63 {
    font-size: 16px;
  }
  .HsCode {
    font-size: 16px;
  }
}
@media screen and (max-width: 1439px) {
  .uc6a2b {
    width: 34px;
    height: 20px;
  }

  .u83191 {
    display: flex;
    margin-top: 12px;
  }

  .hsDes {
    font-size: 24px;
    color: #ffffff;
    font-family: "Arial Bold";
    line-height: 32px;
  }
  .u2ac23 {
    padding: 12px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .trade_tab_item {
    margin-right: 10px;
    line-height: 16px;
    padding: 9px 13px 6px;
  }
  .ubb08b,
  .u5b01d,
  .textu99b63 {
    font-size: 14px;
  }
  .HsCode {
    font-size: 14px;
  }
}
</style>
